import React from 'react';
import { getBookshelfRoot } from '../utils/bookshelf-root';

var Locations = {

  allowlistDomain: ["", "undefined.bookshelf", "vitalsource.com", "vitalsource.co.uk", "vitalbook.com", "cengage.com",
              "phoenix.edu", "minhabiblioteca.com.br", "gilmoreglobal.com",
              "digitalcontenthelp.com", "editoraatlas.com.br", "yuzu.com",
              "bncollege.com", "bookrenter.com", "bookrenterstore.com",
              "itdepartment.nl", "studystore.nl", "brownmackie.edu",
              "brytewave.com", "ccl.org", "vsapplications.com",
              "clever.com", "lww.com", "devryu.net",
              "edx.org", "coursewareobjects.com", "elsevier.com",
              "gsionline.com.br", "senac.br", "heimkaup.is",
              "digitalcontenthelp.com", "gwinnett.k12.ga.us",
              "learningfield.com.au", "mandrelworks.com",
              "bookrenter.com", "bookmarkonline.co.za",
              "bookshelf.nl", "sideriscourseware.com",
              "studieboekencentrale.nl", "textbooks.com",
              "vanschaik.com", "xlibrio.zendesk.com", "xlibrio.com",
              "vsapplications.com", "vstbridge.com", "cengagebrain.com",
              "onedrive.live.com", "google.com", "apple.com", "itunes.com",
              "chegg.com", "www.chegg.com", "miheexplorers.com",
              "follett.com", "clinicalkey.com", "td.org", "redi.mcgrawhill.com", "mcgrawhill.com",
              "talentsmart.com", "suporteminhabiblioteca.zendesk.com", "support.evantage.ca",
              "us.sagepub.com", "sagepub.com", "genealogical.com", "mhe.my.site.com", "emond.ca"],

  allowlistProtocol: [
    "http:",
    "https:",
    "vbk:",
    "bned:",
    "itms-apps:",
    "cheggereader:",
    "ckmeded:",
    "unibb:",
    "manole:",
    "lens:",
    "elsevier:",
    "macmillan:",
    "wiley:"
  ],
  denylistProtocol: ["data:", "data:text", "data:text/html", "xss:", "mysql:", "javascript:"],

  // Performs a safe redirect which warns the user before moving them to
  // a different domain.
  safeRedirect: function(destination, windowOpen, isSafe){
    if (Fraction.Helpers.Locations.requiresRedirectWarning(destination, isSafe)){
      destination = "/#/redirect/"+encodeURIComponent(destination);
    }
    if (windowOpen){
      return window.open(destination, windowOpen);
    } else {
      return window.location = destination;
    }
  },

  blockRedirect(destination){
    var protocol = Fraction.Helpers.Locations.getProtocol(destination);
    var denyListedProtocol = Fraction.Helpers.Locations.denylistProtocol.indexOf(protocol) >= 0;
    if (protocol && denyListedProtocol) { return true; }
    if (!Fraction.Helpers.Locations.isExternalURL(destination)){ return false; }
    if (destination.indexOf("//") === 0){
      destination = window.location.protocol + destination;
    }
    return destination.indexOf(`${protocol}//`) !== 0;
  },

  requiresRedirectWarning: function(destination, isSafe){
    const protocol = Fraction.Helpers.Locations.getProtocol(destination);
    var trustedProtocol = Fraction.Helpers.Locations.allowlistProtocol.indexOf(protocol) >= 0;
    if (protocol && !trustedProtocol && !isSafe) {
      return true;
    }
    if (destination && !Fraction.Helpers.isRelativeURL(destination)){
      try {
        const hostname = Fraction.Helpers.Locations.getHostname(destination);
        if (!isSafe){
          // consider this safe, we cannot have crazy things happening with vbk://
          var domain = Fraction.Helpers.Locations.getDomain(hostname);
          var currentDomain = Fraction.Helpers.Locations.getDomain(window.location.hostname);
          var trustedDomain = domain === currentDomain || Fraction.Helpers.Locations.allowlistDomain.indexOf(domain) >= 0 || Fraction.Helpers.Locations.allowlistDomain.indexOf(hostname) >= 0;
          return (!trustedProtocol || !trustedDomain);
        }
      } catch (e){ // probably an invalid url, return true
        return true;
      }
    }
    return false;
  },

  getURL: function(url){
    var href = document.createElement("a");
    href.href = url;
    return href;
  },

  getHostname: function(url){
    var href = document.createElement("a");
    href.href = url.replace(/.*:\/\//g,'//');
    return href.hostname;
  },

  getProtocol: function(url){
    return Fraction.Helpers.Locations.getURL(url).protocol;
  },

  getDomain: function(host){
    if (host.length === 0){ return ""; }

    if (host === "localhost") {
      return host;
    }

    var hostParts = host.split(".").reverse();
    if (hostParts.length >= 3){
      let tldReg = /^(com|edu|gov|net|mil|org|nom|co|name|info|biz|uk|is|ca)$/i;
      if (hostParts[1].match(tldReg) && hostParts[0].match(tldReg)){
        return `${hostParts[2]}.${hostParts[1]}.${hostParts[0]}`;
      }
    }
    return `${hostParts[1]}.${hostParts[0]}`;
  },

  // Clear any signin redirect
  clearStoredRedirect: function() {
    Fraction.Helpers.setItem('redirectAfterSignIn', JSON.stringify(undefined));
    Fraction.Helpers.setItem('queryAfterSignIn', JSON.stringify(undefined));
  },
  clearRedirect: function(){ // deprecated
    Fraction.redirectAfterSignIn = undefined;
    Fraction.queryAfterSignIn = undefined;
    Fraction.Helpers.clearStoredRedirect();
  },

  redirectUrl: function(){
    if (Fraction.redirectAfterSignIn){
      var queryString = "";
      var url = Fraction.redirectAfterSignIn.join('/');
      if (Fraction.queryAfterSignIn){
        Object.keys(Fraction.queryAfterSignIn).forEach(function(key){
          url = Fraction.Helpers.Locations.addParameter(url, key, Fraction.queryAfterSignIn[key]);
        });
      }
      return url;
    }
    return "/";
  },

  isDenylistedUrl(url) {
    return [
      "",
      "user/signin",
      "terms",
      "user/sso",
      "user/decide",
      "user/complete",
      "user/forgot",
      "activation"
    ].indexOf(url.join("/")) >= 0;
  },

  storeRedirect: function(redirect){
    Fraction.Helpers.clearRedirect();
    Fraction.redirectAfterSignIn = [redirect];
    if (Fraction.Helpers.isDenylistedUrl(Fraction.redirectAfterSignIn)) {
      Fraction.Helpers.clearRedirect();
    } else {
      // Fraction.Helpers.setItem('redirectAfterSignIn', redirect);
    }
  },

  storeAndRedirect: function(destination){
    Fraction.redirectAfterSignIn = Fraction.Router.getRoute();
    Fraction.queryAfterSignIn = Fraction.Router.query;
    if (Fraction.Helpers.isDenylistedUrl(Fraction.redirectAfterSignIn)) {
      Fraction.Helpers.clearRedirect();
    } else {
      // Fraction.Helpers.setItem('redirectAfterSignIn', JSON.stringify(Fraction.redirectAfterSignIn));
      // Fraction.Helpers.setItem('queryAfterSignIn', JSON.stringify(Fraction.queryAfterSignIn));
    }
    Fraction.Router.setRoute(destination);
  },

  redirectMe: function(){
    if (Fraction.redirectAfterSignIn){
      var redirectUrl = Fraction.Helpers.redirectUrl();
      if (Fraction.Helpers.isExternalURL(redirectUrl)){
        Fraction.Helpers.addLoader('body',"top:44px;");
        Fraction.Helpers.addLoader('header',"top:0px;height:44px;bottom:auto;background:#40404c;opacity:0.5;");
        Fraction.Helpers.Locations.safeRedirect(redirectUrl);
        Fraction.Helpers.clearRedirect();
        return;
      } else {
        Fraction.Router.setRoute(redirectUrl);
        Fraction.Helpers.clearRedirect();
      }
    } else {
      Fraction.Router.setRoute('/');
    }
  },

  // check if the given url is external
  // `url` can either be a string or an <a> element
  isExternalURL: function(url) {
    try {
      if (typeof url === 'string' && url.indexOf("javascript:") >= 0){
        // although technically not external, this will prevent automatic redirects
        // and show this as blocked content (only present a 'go back' button)
        return true;
      }
      if (Fraction.Helpers.isRelativeURL(url)){
        return false;
      }
      var appHost = window.location.hostname,
          linkHost = url.hostname;

      if(appHost === linkHost){
        return false;
      }else{
        return true;
      }
    } catch(e) {
      return true;
    }
  },

  // http://stackoverflow.com/questions/10687099/how-to-test-if-a-url-string-is-absolute-or-relative
  isRelativeURL: function(url){
    url = Fraction.Helpers.Locations.getURL(url);
    if (url.hostname === window.location.hostname || url.hostname === ""){
      return true;
    }
    return false;
    /* old code replaced by the above
    var pat = /^https?:\/\//i;
    if (pat.test(url) || url.indexOf("//")===0){
      return false;
    }
    return true;
    */
  },

  ssoToOldOnlineURL: function(dest, newtab, old){
    if (Fraction.User && Fraction.User.email){
      if (newtab){
        var redirectUrl = "/#/redirect/"+encodeURIComponent(dest);
        redirectUrl = Fraction.Helpers.Locations.addParameter(redirectUrl, "sso", "true");
        if (old){
          redirectUrl = Fraction.Helpers.Locations.addParameter(redirectUrl, "old", "true");
        }
        window.open(redirectUrl, '_blank');
      } else {
        if (old){
          Jigsaw.User.oldSSO({destination: dest}, function(response){
            if(response.isSuccess()){
              // response.data.redirect.autoSignin will be the URL to send the user to
              window.location = (response.data.redirect.autoSignin);
            }
          });
        } else {
          Jigsaw.User.SSO({destination: dest}, function(response){
            if(response.isSuccess()){
              // response.data.redirect.autoSignin will be the URL to send the user to
              window.location = (response.data.redirect.autoSignin);
            }
          });
        }
      }
    } else {
      if (newtab){
        Fraction.Helpers.Locations.safeRedirect(dest, "_blank");
      } else {
        Fraction.Helpers.Locations.safeRedirect(dest);
      }
    }
  },

  getParameterByName: function(name) {
    let value = '';
    const beforeHashName = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const afterHashName = name.replace(/[\[\]]/g, "\\$&");

    var regex = new RegExp("[\\?&]" + beforeHashName + "=([^&/?#]*)"),
        results = regex.exec(location.search);

    value = results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));

    // Search after hash if name not found in location.search
    if (!value) {
      regex = new RegExp("[?&]" + afterHashName + "(=([^&#]*)|&|#|$)");
      results = regex.exec(window.location.href);
      if (!results) return '';
      if (!results[2]) return '';
      value = decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    return value;
  },

  // http://stackoverflow.com/questions/1634748/how-can-i-delete-a-query-string-parameter-in-javascript
  removeParameter: function(url, parameter) {
      //prefer to use l.search if you have a location/link object
      var urlparts= url.split('?');
      if (urlparts.length>=2) {

          var prefix= encodeURIComponent(parameter)+'=';
          var pars= urlparts[1].split(/[&;]/g);

          //reverse iteration as may be destructive
          for (var i= pars.length; i-- > 0;) {
              //idiom for string.startsWith
              if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                  pars.splice(i, 1);
              }
          }

          url= urlparts[0]+'?'+pars.join('&');
          return url;
      } else {
          return url;
      }
  },

  addParameter: function(url, parameter, value) {
    parameter = encodeURIComponent(parameter);
    value = encodeURIComponent(value);
    if (url.indexOf('?') === -1){
      return url + "?" + parameter + "=" + value;
    } else {
      var parts = url.split('?');
      return parts[0] + "?" + parameter + "=" + value + "&" + parts[1];
    }
  },

  systemError: function(errorCode) {
    errorCode = errorCode || 500;
    getBookshelfRoot().render(
      <Fraction.Error errorCode={errorCode} />
    );
  },

  buildOptOutUrl() {
    var url = Fraction.Brand.OptOut.url;
    if (url.slice(-1) !== '/') {
      url += '/';
    }
    url += "sso/";
    const tokens = Fraction.User.contextTokens;
    if (tokens && !$.isEmptyObject(tokens)) {
      const key = Object.keys(tokens)[0];
      const token = tokens[key];
      url += token;
    }
    return url;
  },

  buildScoreCentertUrl(isbn) {
    let url  = Fraction.Brand.ScoreCenter.url;

    // Get the correct context token
    let token;
    if (!Object.keys(Fraction.User.contextTokens).length){
      // No Token
      token = null;
    } else if (isbn && Fraction.User.contextTokens[isbn]){
      token = Fraction.User.contextTokens[isbn];
    } else {
      const firstToken = Object.keys(Fraction.User.contextTokens)[0];
      token = Fraction.User.contextTokens[firstToken];
    }

    if (isbn) {
      url = url.replace(/\/$/,"") + `/books/${isbn}`;
    }

    const contextToken = "?context_token="+token;
    return url + contextToken;
  }

};

module.exports = Locations;
